import { useFela } from 'react-fela';
import { FormattedMessage, useIntl } from 'react-intl';

import { config } from '@/config/config';
import { Checkbox, Form, FormField, TextInput } from '@/modules/forms';
import { Heading, Link, Text } from '@/modules/ui';

import { useSubmitReviewPrizepoolForm } from '../../../hooks';
import { reviewPrizepoolFormSchema, type ReviewPrizepoolFormSchemaType, type ReviewPrizepoolFormValues } from '../../../schemas';
import { FormButtons } from './FormButtons';
import * as felaRules from './ReviewPrizepoolForm.rules';
import { ReviewSites } from './ReviewSites';

export interface ReviewPrizepoolFormProps {
    onSubmitSuccess: () => void;
    onClose: () => void;
}

export const ReviewPrizepoolForm = ({ onSubmitSuccess, onClose }: ReviewPrizepoolFormProps) => {
    const { css } = useFela();
    const { formatMessage } = useIntl();

    const { handleSubmit, defaultValues, isSubmitting } = useSubmitReviewPrizepoolForm({ onSubmitSuccess });

    return (
        <Form<ReviewPrizepoolFormSchemaType, ReviewPrizepoolFormValues>
            schema={reviewPrizepoolFormSchema}
            onSubmit={handleSubmit}
            defaultValues={defaultValues}
        >
            <Text>
                <FormattedMessage id='review-prizepool.form.description' />
            </Text>

            <ReviewSites />

            <Heading elementType='h2' color='black' customStyle={felaRules.heading}>
                <FormattedMessage id='review-prizepool.form.personalInfo.title' />
            </Heading>

            <div className={css(felaRules.inputsContainer)}>
                <FormField name='name' label={<FormattedMessage id='review-prizepool.form.personalInfo.name.title' />} required>
                    <TextInput name='name' placeholder={formatMessage({ id: 'review-prizepool.form.personalInfo.name.placeholder' })} />
                </FormField>
                <FormField name='email' label={<FormattedMessage id='review-prizepool.form.personalInfo.email.title' />} required>
                    <TextInput name='email' placeholder={formatMessage({ id: 'review-prizepool.form.personalInfo.email.placeholder' })} />
                </FormField>
                <FormField name='tocAgreement'>
                    <Checkbox name='tocAgreement'>
                        <FormattedMessage
                            id='review-prizepool.form.personalInfo.tocAgreement'
                            values={{
                                link: chunks => (
                                    <Link type='native' href={config.links.reviewPrizepoolTermsAndConditions} color='foregroundsSecondary'>
                                        {chunks}
                                    </Link>
                                ),
                            }}
                        />
                    </Checkbox>
                </FormField>
            </div>
            <div className={css(felaRules.buttonsContainer)}>
                <FormButtons isSubmitting={isSubmitting} onClose={onClose} />
            </div>
        </Form>
    );
};
